module.exports = __webpack_public_path__ + "static/media/logo.90d36db4.svg";